import {
  GetAccountInfoApiProps,
  GetAccountInfoARApiProps,
  UpdateAliasApiProps,
  UpdateAliasResponseApiProps,
  UpdateAliasErrorResponseProps,
} from 'services/account-info/types'
import { getAccountInfo, getAccountInfoAR, updateAlias } from 'services/account-info'

import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from '@tanstack/react-query'

type UseGetAccountInfoOptions = Omit<
  UseQueryOptions<GetAccountInfoApiProps>,
  'queryKey' | 'queryFn'
>
type UseGetAccountInfoAROptions = Omit<
  UseQueryOptions<GetAccountInfoARApiProps>,
  'queryKey' | 'queryFn'
>

export const useGetAccountInfo = (options?: UseGetAccountInfoOptions) =>
  useQuery<GetAccountInfoApiProps>(['account-info'], () => getAccountInfo(), options)

export const useGetAccountInfoAR = (
  account: string,
  localization?: string,
  options?: UseGetAccountInfoAROptions,
) =>
  useQuery<GetAccountInfoARApiProps>(
    ['account-info-ar', account, localization],
    () => getAccountInfoAR(account, localization),
    options,
  )

export const useUpdateAlias = (
  options?: UseMutationOptions<
    UpdateAliasResponseApiProps,
    UpdateAliasErrorResponseProps,
    UpdateAliasApiProps
  >,
) =>
  useMutation<UpdateAliasResponseApiProps, UpdateAliasErrorResponseProps, UpdateAliasApiProps>(
    ['update-alias'],
    async (props) => {
      try {
        return await updateAlias(props)
      } catch (error) {
        const outerError = typeof error === 'string' ? JSON.parse(error) : error
        const parsedError =
          typeof outerError?.response === 'string'
            ? JSON.parse(outerError.response)
            : outerError?.response

        const err = Object.assign(new Error(), parsedError ?? outerError ?? error)
        throw err
      }
    },
    options,
  )
